import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { login } from "@/redux/actions/session-action-types";

function SessionWrapper({ children }) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  // We want to check the session on app load, but we don't want to do this if we're already signing out the user
  const isSessionChecked = useSelector(
    (state) => state.session?.isSessionChecked,
  );

  useEffect(() => {
    // If the session hasn't been checked and we're not already signing out the user, check the session
    if (!isSessionChecked && pathname !== "/signout") {
      dispatch(login());
    }
  }, [dispatch, isSessionChecked, pathname]);

  // If the session hasn't been checked and we're not already signing out the user, show a loading screen
  if (!isSessionChecked && pathname !== "/signout") {
    return (
      <div
        className="d-flex flex-column min-vh-100"
        style={{ marginTop: "-3.5rem" }}
      >
        <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
          {/* Maring left due to the image containing a load of spacing to the right */}
          <img
            src="/images/dragonflyai-logo.svg"
            height="42"
            alt="Dragonfly"
            style={{ marginLeft: "153px" }}
          />
          <p className="lead mt-2">Please wait...</p>
        </div>
      </div>
    );
  }

  return children;
}

export default SessionWrapper;
